import { render, staticRenderFns } from "./GestorEmpresas.vue?vue&type=template&id=9d2aee90&scoped=true"
import script from "./GestorEmpresas.vue?vue&type=script&lang=js"
export * from "./GestorEmpresas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2aee90",
  null
  
)

export default component.exports